import React, { useEffect, useState } from 'react';
interface TopBarProps {
  onRegisterClick: () => void;
  seatsTaken: number; // 0–100
  seatsTotal?: number;
}
export function TopBar({
  onRegisterClick,
  seatsTaken,
  seatsTotal = 100
}: TopBarProps) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 200);
    return () => clearTimeout(t);
  }, []);
  const seatsLeft = Math.max(0, seatsTotal - seatsTaken);
  const progress = mounted ? Math.min(100, seatsTaken / seatsTotal * 100) : 0;
  const SeatsCounter = ({
    compact = false
  }: {
    compact?: boolean;
  }) => <div className={`flex flex-col w-full ${compact ? '' : 'max-w-md px-4'}`} data-id="element-215">
      <div className="flex justify-between items-center w-full mb-1.5" data-id="element-216">
        <div className="flex items-center gap-2" data-id="element-217">
          <span className="relative flex h-2.5 w-2.5" data-id="element-218">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-219"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" data-id="element-220"></span>
          </span>
          <span className="font-display font-bold text-white uppercase" style={{
          fontSize: '13px',
          letterSpacing: '0.1em'
        }} data-id="element-221">
            Live Seats
          </span>
        </div>
        <span className="font-display font-bold text-brand-gold tabular-nums" style={{
        fontSize: '16px',
        letterSpacing: '0.05em'
      }} data-id="element-222">
          {seatsLeft} OF {seatsTotal} LEFT
        </span>
      </div>
      <div className="relative w-full rounded-full overflow-hidden" style={{
      height: '10px',
      backgroundColor: '#1A3A7A',
      border: '1px solid rgba(212, 175, 55, 0.4)',
      boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.45)'
    }} data-id="element-223">
        <div className="absolute inset-y-0 left-0 transition-all duration-700 ease-out" style={{
        width: `${progress}%`,
        background: 'linear-gradient(180deg, #F4DC8C 0%, #D4AF37 55%, #A87E1F 100%)',
        boxShadow: 'inset 0 1px 0 #F4DC8C, 0 0 10px rgba(212, 175, 55, 0.65)',
        borderTopLeftRadius: '9999px',
        borderBottomLeftRadius: '9999px',
        borderTopRightRadius: progress >= 99 ? '9999px' : 0,
        borderBottomRightRadius: progress >= 99 ? '9999px' : 0
      }} data-id="element-224" />
      </div>
    </div>;
  return <header className="fixed top-0 left-0 right-0 z-50 bg-brand-navy shadow-lg" style={{
    borderBottom: '1px solid rgba(255, 255, 255, 0.08)'
  }} data-id="element-225">
      <div className="container mx-auto px-4 flex items-center justify-between gap-4" style={{
      minHeight: '56px'
    }} data-id="element-226">
        <div className="flex-shrink-0" data-id="element-227">
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} className="font-script text-white text-2xl md:text-3xl leading-none tracking-wide hover:text-brand-gold transition-colors" aria-label="Fast Profit — go to top" data-id="element-228">
            Fast Profit
          </button>
        </div>

        <div className="hidden md:flex flex-1 justify-center items-center" data-id="element-229">
          <SeatsCounter data-id="element-230" />
        </div>

        <div className="flex-shrink-0" data-id="element-231">
          <button onClick={onRegisterClick} className="bg-brand-gold hover:bg-[#d4b455] text-black font-display font-bold uppercase text-xs md:text-base px-4 md:px-7 py-2.5 md:py-3 rounded-full transition-all hover:-translate-y-0.5 hover:shadow-[0_0_18px_rgba(212,175,55,0.6)] tracking-wider" data-id="element-232">
            Secure Ticket
          </button>
        </div>
      </div>

      <style data-id="element-233">{`
        @media (min-width: 768px) {
          header > div:first-of-type { min-height: 64px !important; }
        }
      `}</style>

      <div className="md:hidden bg-brand-blue px-4 py-2.5 border-t border-brand-gold/20" data-id="element-234">
        <SeatsCounter compact data-id="element-235" />
      </div>
    </header>;
}